'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.templateStatusQuery = templateStatusQuery;
exports.asyncDownloadTemplate = asyncDownloadTemplate;
exports.queryAsyncTemplateResponse = queryAsyncTemplateResponse;

var _requestOlympics = require('@ali/request-olympics');

var _requestOlympics2 = _interopRequireDefault(_requestOlympics);

var _request = require('../../adapter/request');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 模板状态查询
 * @param {Object} params 请求参数
 * @param {Object} envents 事件回调
 * @param {Number} times 请求次数
 * @param {Number} interval  请求间隔
 */
function templateStatusQuery(params, events) {
  var MAX_TIMES = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 180;
  var interval = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 2e3;
  var onProgress = events.onProgress,
      onSuccess = events.onSuccess,
      onError = events.onError,
      onAbort = events.onAbort;

  var currentProgress = 0;

  var _abort = false;
  var sequenceNo = params.sequenceNo,
      tablePropertyId = params.tablePropertyId,
      matterId = params.matterId;

  var progressCall = function progressCall() {
    return queryAsyncTemplateResponse({ sequenceNo: sequenceNo, tablePropertyId: tablePropertyId, matterId: matterId }).then(function (data) {
      if (_abort) {
        onAbort && onAbort();
        return;
      }

      // 该状态下  成功航司
      if (data.status === 'PROCESS_FINISHED') {
        onSuccess(data);
        return;
      }

      if (currentProgress >= MAX_TIMES) {
        onError(new Error('等待超时'), null);
        return;
      }

      // 该状态下 仅仅通知   不中止流程
      if (data.status === 'PROCESSING') {
        onProgress(data);
      }

      currentProgress++;
      return new Promise(function (resolve) {
        setTimeout(resolve, interval);
      }).then(progressCall);
    }).catch(onError);
  };

  asyncDownloadTemplate(params).then(progressCall).catch(onError);
  queryAsyncTemplateResponse({ sequenceNo: sequenceNo, tablePropertyId: tablePropertyId }).then(resErrorJudge);
  return {
    abort: function abort() {
      return _abort = true;
    }
  };
}

function asyncDownloadTemplate(params) {
  return _requestOlympics2.default.post((0, _request.transformUrl)('/form/table/asyncDownloadTemplate'), params).then(resErrorJudge);
}

function queryAsyncTemplateResponse(params) {
  return _requestOlympics2.default.get((0, _request.transformUrl)('/form/table/queryAsyncTemplateResponse'), { params: _extends({}, params, { timestamp: new Date().getTime() }) }).then(resErrorJudge);
}

/**
 *判断返回值
 * @param {Object} res 返回值
 * @returns Promise.reject or Promise.resolve
 */
function resErrorJudge(res) {
  if (!res || !res.success) {
    return Promise.reject(res);
  }
  return Promise.resolve(res.data);
}